import { render, staticRenderFns } from "./IconSjnk.vue?vue&type=template&id=19252e43"
import script from "./IconSjnk.vue?vue&type=script&lang=js"
export * from "./IconSjnk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports